import store from '../redux/store';

export const hasRole = (role) => {
    return store.getState().auth.role === role;
}